import { BROWSER_NAMES, MOBILE_NAMES, SCREEN_SIZE_768 } from 'appConstants';
import { MiscUtils } from './MiscUtils';

declare global {
  interface Window {
    MSInputMethodContext?: object;
  }

  interface Document {
    documentMode?: string;
  }
}

// IE 11 check
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

// For supportsDateInputType check
const input = document.createElement('input');
input.setAttribute('type', 'date');

const invalidDateValue = 'invalid-date-value';
input.setAttribute('value', invalidDateValue);

const BrowserUtils = {
  // is the browser Internet Explorer 11?
  isIE11,

  // check that the browser sanitizes the invalid value
  supportsDateInputType: input.value !== invalidDateValue,

  /** Checks active Element with ID for IE browser */
  checkActiveElementForIe: (id: string, activeElement?: Element | null) =>
    isIE11 && activeElement && activeElement.id === id,

  getBrowserDetails: () => {
    return {
      browserDetails: BrowserUtils.getBrowserVersion(),
      browserDimensions: BrowserUtils.getBrowserDimensions(),
      deviceDetails: BrowserUtils.getDeviceDetails(),
    };
  },

  getBrowserDimensions: (): string =>
    window.innerWidth + 'x' + window.innerHeight,

  /**
   * Get current browser name and version
   */
  getBrowserVersion: (): string => {
    const browserAgent = window.navigator.userAgent;
    let browserDetails = '';
    let offset, ix;
    offset = MiscUtils.getIndexOfMatch(browserAgent, BROWSER_NAMES);
    if (offset === -1) {
      offset = browserAgent.lastIndexOf(' ') + 1;
    }
    browserDetails = browserAgent.substring(offset);
    /**
     * Trimming the fullVersion string at
     *  semicolon/space if present
     */
    if (
      (ix = browserDetails.indexOf(';')) !== -1 ||
      (ix = browserDetails.indexOf(' ')) !== -1
    ) {
      browserDetails = browserDetails.substring(0, ix);
    }
    return browserDetails;
  },

  /**
   * Get current device name, if any, used by user.
   */
  getDeviceDetails: (): string => {
    const browserAgent = navigator.userAgent;
    const offset = MiscUtils.getIndexOfMatch(browserAgent, MOBILE_NAMES);
    if (offset !== -1) {
      let mobileString = browserAgent.substring(offset);
      let ix;
      if (
        (ix = mobileString.indexOf(';')) !== -1 ||
        (ix = mobileString.indexOf(' ')) !== -1
      ) {
        mobileString = mobileString.substring(0, ix);
      }
      return mobileString;
    }
    return 'Not a mobile device';
  },

  // Get mobile width less than or equal 768px
  isScreenSize768: (): boolean => window.innerWidth <= SCREEN_SIZE_768,
};

export { BrowserUtils };
